import {
    CLOSE_RECOMMENDATIONS_MODAL,
    RecommendationsModalAction,
    SET_RECOMMENDATIONS_MODAL_DATA
} from '../actions/recommendations-modal';
import { RecommendationsModalState } from '../typings/recommendations';

const initialState = {
    isVisible: false,
    data: [],
    headerHint: ''
};

export const recommendationModalReducer = (
    state: RecommendationsModalState = initialState,
    action: RecommendationsModalAction
): RecommendationsModalState => {
    switch (action.type) {
        case SET_RECOMMENDATIONS_MODAL_DATA:
            return action.modalData;
        case CLOSE_RECOMMENDATIONS_MODAL:
            return initialState;
        default:
            return state;
    }
};
